export const utils = {
  data() {
    return {}
  },
  methods: {
    isEmpty(obj) {
      if (obj) {
        return Object.keys(obj).length === 0
      }
    }
  }
}
